<div class="container">
     <div class="section-title">
            <span>Our Services</span>
            <h3>Expolre Our Data Services</h3>
        </div>
    <div class="row">
        <div class="col-lg-4 col-md-6" *ngFor="let service of servicesData">
            <div class="single-services-box">
                <div class="icon">
                    <i class="flaticon-big-data"></i>
                </div>
                <div >
                <h3>{{service.serviceName}}</h3>
                </div>
                <div class="mt-3">
                    <p [outerHTML]="service.serviceDescription.substring(0,250) ">...</p>
                </div>
                <div class="services-btn">
                    <a routerLink="/services-details/{{service.id}}" class="services-btn-one">Read More <i class="flaticon-right"></i></a>
                </div>
            </div>
        </div>

    </div>
</div>
